var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4849_215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4849_215",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4849_215)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.584 16.6667C29.5045 16.6667 30.2507 15.9205 30.2507 15C30.2507 14.0795 29.5045 13.3333 28.584 13.3333C27.6635 13.3333 26.9174 14.0795 26.9174 15C26.9174 15.9205 27.6635 16.6667 28.584 16.6667Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.584 26.6667C29.5045 26.6667 30.2507 25.9205 30.2507 25C30.2507 24.0795 29.5045 23.3333 28.584 23.3333C27.6635 23.3333 26.9174 24.0795 26.9174 25C26.9174 25.9205 27.6635 26.6667 28.584 26.6667Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.9167 21.6667C33.8372 21.6667 34.5833 20.9205 34.5833 20C34.5833 19.0795 33.8372 18.3333 32.9167 18.3333C31.9962 18.3333 31.25 19.0795 31.25 20C31.25 20.9205 31.9962 21.6667 32.9167 21.6667Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.3338 16.6667C12.2543 16.6667 13.0005 15.9205 13.0005 15C13.0005 14.0795 12.2543 13.3333 11.3338 13.3333C10.4134 13.3333 9.66718 14.0795 9.66718 15C9.66718 15.9205 10.4134 16.6667 11.3338 16.6667Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.3338 26.6667C12.2543 26.6667 13.0005 25.9205 13.0005 25C13.0005 24.0795 12.2543 23.3333 11.3338 23.3333C10.4134 23.3333 9.66718 24.0795 9.66718 25C9.66718 25.9205 10.4134 26.6667 11.3338 26.6667Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.00035 21.6667C7.92081 21.6667 8.66701 20.9205 8.66701 20C8.66701 19.0795 7.92081 18.3333 7.00035 18.3333C6.07986 18.3333 5.33368 19.0795 5.33368 20C5.33368 20.9205 6.07986 21.6667 7.00035 21.6667Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.5007 10.332C27.4212 10.332 28.1673 9.58583 28.1673 8.66537C28.1673 7.74488 27.4212 6.9987 26.5007 6.9987C25.5802 6.9987 24.834 7.74488 24.834 8.66537C24.834 9.58583 25.5802 10.332 26.5007 10.332Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.5002 10.332C14.4206 10.332 15.1668 9.58583 15.1668 8.66537C15.1668 7.74488 14.4206 6.9987 13.5002 6.9987C12.5797 6.9987 11.8335 7.74488 11.8335 8.66537C11.8335 9.58583 12.5797 10.332 13.5002 10.332Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.0838 11.6667C21.0043 11.6667 21.7505 10.9205 21.7505 10C21.7505 9.07954 21.0043 8.33334 20.0838 8.33334C19.1633 8.33334 18.4172 9.07954 18.4172 10C18.4172 10.9205 19.1633 11.6667 20.0838 11.6667Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.5007 33.3333C27.4212 33.3333 28.1673 32.5872 28.1673 31.6667C28.1673 30.7462 27.4212 30 26.5007 30C25.5802 30 24.834 30.7462 24.834 31.6667C24.834 32.5872 25.5802 33.3333 26.5007 33.3333Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.5002 33.3333C14.4206 33.3333 15.1668 32.5872 15.1668 31.6667C15.1668 30.7462 14.4206 30 13.5002 30C12.5797 30 11.8335 30.7462 11.8335 31.6667C11.8335 32.5872 12.5797 33.3333 13.5002 33.3333Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.0838 31.9987C21.0043 31.9987 21.7505 31.2525 21.7505 30.332C21.7505 29.4115 21.0043 28.6653 20.0838 28.6653C19.1633 28.6653 18.4172 29.4115 18.4172 30.332C18.4172 31.2525 19.1633 31.9987 20.0838 31.9987Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 17.0833C24.0673 17.0833 25 16.1506 25 15C25 13.8494 24.0673 12.9167 22.9166 12.9167C21.766 12.9167 20.8333 13.8494 20.8333 15C20.8333 16.1506 21.766 17.0833 22.9166 17.0833Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 17.0833C18.234 17.0833 19.1667 16.1506 19.1667 15C19.1667 13.8494 18.234 12.9167 17.0833 12.9167C15.9327 12.9167 15 13.8494 15 15C15 16.1506 15.9327 17.0833 17.0833 17.0833Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 22.0833C26.984 22.0833 27.9167 21.1507 27.9167 20C27.9167 18.8493 26.984 17.9167 25.8333 17.9167C24.6827 17.9167 23.75 18.8493 23.75 20C23.75 21.1507 24.6827 22.0833 25.8333 22.0833Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 22.0833C15.3172 22.0833 16.25 21.1507 16.25 20C16.25 18.8493 15.3172 17.9167 14.1666 17.9167C13.016 17.9167 12.0833 18.8493 12.0833 20C12.0833 21.1507 13.016 22.0833 14.1666 22.0833Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 27.0833C18.234 27.0833 19.1667 26.1507 19.1667 25C19.1667 23.8493 18.234 22.9167 17.0833 22.9167C15.9327 22.9167 15 23.8493 15 25C15 26.1507 15.9327 27.0833 17.0833 27.0833Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 27.0833C24.0673 27.0833 25 26.1507 25 25C25 23.8493 24.0673 22.9167 22.9166 22.9167C21.766 22.9167 20.8333 23.8493 20.8333 25C20.8333 26.1507 21.766 27.0833 22.9166 27.0833Z",
    fill: "#E72F0D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0001 5.55013C19.1835 5.55013 18.5335 4.90013 18.5335 4.08347C18.5335 3.2668 19.1835 2.63347 20.0001 2.63347C20.8168 2.63347 21.4668 3.28347 21.4668 4.10013C21.4668 4.9168 20.8168 5.55013 20.0001 5.55013Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.7503 5.99935C28.0503 5.99935 27.4837 5.43268 27.4837 4.74935C27.4837 4.06602 28.0503 3.49935 28.7337 3.49935C29.417 3.49935 30.0003 4.06602 30.0003 4.74935C30.0003 5.43268 29.4503 5.99935 28.7503 5.99935Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.25 5.99935C10.5667 5.99935 10 5.43268 10 4.74935C10 4.06602 10.55 3.49935 11.25 3.49935H11.2667C11.95 3.49935 12.5167 4.06602 12.5167 4.74935C12.5167 5.43268 11.95 5.99935 11.25 5.99935Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0001 37.2985C19.1835 37.2985 18.5335 36.6485 18.5335 35.8318C18.5335 35.0152 19.1835 34.3652 20.0001 34.3652C20.8168 34.3652 21.4668 35.0152 21.4668 35.8318C21.4668 36.6485 20.8168 37.2985 20.0001 37.2985Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.7503 36.416C28.0503 36.416 27.4837 35.8493 27.4837 35.166C27.4837 34.4827 28.0503 33.916 28.7337 33.916C29.417 33.916 30.0003 34.4827 30.0003 35.166C30.0003 35.8493 29.4503 36.416 28.7503 36.416Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.25 36.416C10.5667 36.416 10 35.8493 10 35.166C10 34.4827 10.55 33.916 11.25 33.916H11.2667C11.95 33.916 12.5167 34.4827 12.5167 35.166C12.5167 35.8493 11.95 36.416 11.25 36.416Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.58318 21.4652C1.78318 21.4652 1.11652 20.8152 1.11652 20.0152V19.9985C1.11652 19.1985 1.76651 18.5318 2.58318 18.5318C3.39985 18.5318 4.03318 19.1818 4.03318 19.9985C4.03318 20.8152 3.38318 21.4652 2.58318 21.4652Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.25 29.5837C5.56667 29.5837 5 29.017 5 28.3337V28.317C5 27.6337 5.56667 27.067 6.25 27.067C6.93333 27.067 7.5 27.6337 7.5 28.317C7.5 29.0003 6.93333 29.5837 6.25 29.5837Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.25 12.9329C5.56667 12.9329 5 12.3663 5 11.6829C5 10.9996 5.56667 10.4329 6.25 10.4329C6.93333 10.4329 7.5 10.9829 7.5 11.6663V11.6829C7.5 12.3663 6.93333 12.9329 6.25 12.9329Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.5001 21.4652C36.7001 21.4652 36.0335 20.8152 36.0335 20.0152V19.9985C36.0335 19.1985 36.6835 18.5318 37.5001 18.5318C38.3168 18.5318 38.9668 19.1818 38.9668 19.9985C38.9668 20.8152 38.3001 21.4652 37.5001 21.4652Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.833 29.5837C33.1497 29.5837 32.583 29.0337 32.583 28.3337V28.317C32.583 27.6337 33.1497 27.067 33.833 27.067C34.5163 27.067 35.083 27.6337 35.083 28.317C35.083 29.0003 34.5163 29.5837 33.833 29.5837Z",
    fill: "#E72F0D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.833 12.9329C33.1497 12.9329 32.583 12.3663 32.583 11.6829C32.583 10.9996 33.1497 10.4329 33.833 10.4329C34.5163 10.4329 35.083 10.9829 35.083 11.6663V11.6829C35.083 12.3663 34.5163 12.9329 33.833 12.9329Z",
    fill: "#E72F0D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4849_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.9f194d553f014c5d1ade9bbe2cdb5dad.svg";
export { ForwardRef as ReactComponent };